import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

function timeAgo(date) {
  if (!date) return 'Nunca acessou';
  const d = (Date.now()-new Date(date))/1000/86400;
  if (d<1) return 'Hoje'; if (d<2) return 'Ontem'; return `Há ${Math.floor(d)} dias`;
}

export default function MentorDashboard() {
  const { token } = useAuth();
  const [data, setData] = useState(null);
  const [alertas, setAlertas] = useState([]);
  const [ranking, setRanking] = useState([]);
  const [vencimentos, setVencimentos] = useState([]);
  const [turmas, setTurmas] = useState([]);
  const [turmaSel, setTurmaSel] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/mentor/dashboard', token).then(setData);
    api.get('/mentor/alertas-prazo', token).then(setAlertas).catch(()=>{});
    api.get('/mentor/vencimentos', token).then(setVencimentos).catch(()=>{});
    api.get('/turmas', token).then(setTurmas).catch(()=>{});
  }, [token]);

  useEffect(() => {
    const url = turmaSel ? `/mentor/ranking?turma_id=${turmaSel}` : '/mentor/ranking';
    api.get(url, token).then(setRanking).catch(()=>{});
  }, [token, turmaSel]);

  if (!data) return <div style={{padding:32,color:'#6B7289'}}>Carregando...</div>;

  const { stats, porFase, inativos, porTurma } = data;

  return (
    <div style={{padding:'28px 32px'}}>
      <div style={{marginBottom:24}}>
        <div style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em'}}>Torre de Controle</div>
        <div style={{fontSize:13,color:'#6B7289',marginTop:3}}>Visão geral do programa em tempo real</div>
      </div>

      {/* Cards de resumo */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',gap:10,marginBottom:20}}>
        {[
          ['Alunos ativos', stats.total_alunos, '#1A2ECC'],
          ['Turmas', stats.total_turmas, '#8B5CF6'],
          ['Operações', stats.total_operacoes, '#0FA36B'],
          ['Tarefas concluídas', stats.total_tarefas, '#E6A817'],
          ['Conquistas', stats.total_conquistas, '#EC4899'],
        ].map(([l,v,c])=>(
          <div key={l} className="card" style={{padding:14}}>
            <div style={{fontSize:9,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.08em',fontWeight:500}}>{l}</div>
            <div style={{fontSize:22,fontWeight:700,color:c,marginTop:4}}>{v}</div>
          </div>
        ))}
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16,marginBottom:16}}>
        {/* Processos Atrasados */}
        <div className="card">
          <div style={{fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:14}}>⏰ Processos Atrasados</div>
          {alertas.length===0 && <div style={{fontSize:13,color:'#6B7289'}}>Nenhum processo atrasado.</div>}
          {alertas.map(a=>(
            <div key={a.aluno_id} onClick={()=>navigate('/mentor/alunos/'+a.aluno_id)}
              style={{display:'flex',alignItems:'flex-start',gap:10,padding:'8px 0',borderBottom:'0.5px solid #E4E6EF',cursor:'pointer'}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:600,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.aluno_nome}</div>
                <div style={{fontSize:11,color:'#6B7289',marginTop:1}}>{a.email}</div>
                <div style={{fontSize:10,color:'#D63B3B',marginTop:1}}>{a.total_atrasados} fase{a.total_atrasados>1?'s':''}  atrasada{a.total_atrasados>1?'s':''}</div>
              </div>
              <span style={{fontSize:10,color:'#D63B3B',fontWeight:600,flexShrink:0,background:'#FDEAEA',padding:'2px 6px',borderRadius:4}}>Atrasado</span>
            </div>
          ))}
        </div>

        {/* Por turma */}
        <div className="card">
          <div style={{fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:14}}>Por Turma</div>
          {porTurma?.map(t=>(
            <div key={t.nome} style={{display:'flex',alignItems:'center',gap:10,marginBottom:8,padding:'8px 0',borderBottom:'0.5px solid #E4E6EF'}}>
              <div style={{flex:1}}>
                <div style={{fontSize:12,fontWeight:500}}>{t.nome}</div>
                <div style={{fontSize:10,color:'#6B7289'}}>{t.alunos} aluno{t.alunos!=1?'s':''}</div>
              </div>
              <div style={{fontSize:11,color:'#6B7289'}}>Média: {parseFloat(t.media_tarefas||0).toFixed(0)} tarefas</div>
            </div>
          ))}
          {!porTurma?.length && <div style={{fontSize:12,color:'#6B7289'}}>Nenhuma turma cadastrada</div>}
        </div>
      </div>

      {/* Alertas de vencimento */}
      {vencimentos.length > 0 && (
        <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:10,padding:'12px 16px',marginBottom:16}}>
          <div style={{fontSize:13,fontWeight:600,color:'#92400E',marginBottom:8}}>
            ⏰ {vencimentos.length} plano{vencimentos.length>1?'s vencendo':' vencendo'} nos próximos 30 dias
          </div>
          {vencimentos.slice(0,5).map(v=>(
            <div key={v.id} style={{display:'flex',justifyContent:'space-between',fontSize:12,color:'#92400E',marginBottom:4}}>
              <span>{v.nome} {v.turma_nome && `(${v.turma_nome})`}</span>
              <span style={{fontWeight:600}}>
                {v.dias_restantes < 0 ? `Vencido há ${Math.abs(v.dias_restantes)}d` : 
                 v.dias_restantes === 0 ? 'Vence hoje!' : `${v.dias_restantes}d restantes`}
              </span>
            </div>
          ))}
        </div>
      )}

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>
        {/* Inativos */}
        <div className="card">
          <div style={{fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:14}}>⚠️ Alunos Inativos</div>
          {inativos.length===0 && <div style={{fontSize:13,color:'#6B7289'}}>Nenhum aluno inativo.</div>}
          {inativos.map(a=>(
            <div key={a.id} onClick={()=>navigate(`/mentor/alunos/${a.id}`)}
              style={{display:'flex',alignItems:'center',gap:10,padding:'8px 0',borderBottom:'0.5px solid #E4E6EF',cursor:'pointer'}}>
              <div style={{flex:1}}>
                <div style={{fontSize:12,fontWeight:500}}>{a.nome}</div>
                <div style={{fontSize:10,color:'#D63B3B'}}>{timeAgo(a.ultimo_acesso)}</div>
              </div>
              <span className="badge badge-red" style={{fontSize:9}}>{Math.floor(a.dias_inativo||0)}d</span>
            </div>
          ))}
        </div>

        {/* Ranking */}
        <div className="card" style={{padding:0,overflow:'hidden'}}>
          <div style={{padding:'12px 14px',borderBottom:'0.5px solid #E4E6EF',display:'flex',alignItems:'center',gap:10}}>
            <span style={{fontSize:12,fontWeight:600,color:'#6B7289',textTransform:'uppercase',letterSpacing:'.06em',flex:1}}>🏆 Ranking</span>
            <select value={turmaSel} onChange={e=>setTurmaSel(e.target.value)}
              style={{fontSize:11,border:'0.5px solid #E4E6EF',borderRadius:6,padding:'3px 8px',background:'#fff',cursor:'pointer'}}>
              <option value="">Todas as turmas</option>
              {turmas.map(t=><option key={t.id} value={t.id}>{t.nome}</option>)}
            </select>
          </div>
          {ranking.slice(0,8).map((r,i)=>(
            <div key={r.id} style={{display:'flex',alignItems:'center',gap:10,padding:'10px 14px',borderBottom:'0.5px solid #E4E6EF',cursor:'pointer'}}
              onClick={()=>navigate(`/mentor/alunos/${r.id}`)}>
              <div style={{width:22,height:22,borderRadius:6,
                background:i===0?'#F0C52A':i===1?'#C0C0C0':i===2?'#CD7F32':'#F4F5F9',
                color:i<3?'#fff':'#6B7289',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,fontSize:11,flexShrink:0}}>
                {i+1}
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:12,fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.nome}</div>
                <div style={{fontSize:10,color:'#9095A8'}}>{r.turma_nome||r.turma}</div>
              </div>
              <div style={{fontSize:12,fontWeight:600,color:'#E6A817'}}>{parseFloat(r.pontuacao).toFixed(0)}pts</div>
            </div>
          ))}
          {ranking.length===0 && <div style={{padding:16,fontSize:12,color:'#6B7289',textAlign:'center'}}>Nenhum dado</div>}
        </div>
      </div>
    </div>
  );
}
